import request from "@/utils/request";

// 获取oss授权
export function getOssStsToken(params) {
  return request({
    url: "/ework2/sys/file/getOssStsToken",
    method: "get",
    params,
  });
}
// 登录
export function login(params) {
  return request({
    url: `/ucapi/auth/login/verificationCode/void/${process.env.VUE_APP_ID}`,
    method: "get",
    params,
  });
}
export function loginPassword(params) {
  return request({
    url: `/ucapi/auth/login/password/${process.env.VUE_APP_ID}`,
    method: "get",
    params,
  });
}
export function password_v2(data) {
  return request({
    url: `/ucapi/auth/login/password_v2/${process.env.VUE_APP_ID}`,
    method: "post",
    data: data,
  });
}

export function getUserInfo(params) {
  return request({
    url: `/ucapi/user/getUserInfo/wechat_mp/${process.env.VUE_APP_ID}`,
    method: "get",
    params,
  });
}

// 获取验证码
export function captcha(params) {
  return request({
    url: `/ucapi/captcha/sms/${process.env.VUE_APP_ID}`,
    method: "get",
    params,
  });
}

// 获取验证码
export function completeUserInfo(data) {
  return request({
    url: `/ucapi/auth/completeUserInfo/${process.env.VUE_APP_ID}`,
    method: "post",
    data: data,
  });
}
export function getCode_v2(params) {
  return request({
    url: `/ucapi/captcha/image_v2/${process.env.VUE_APP_ID}`,
    method: "get",
    params,
  });
}
// 获取图形验证码

export function getCode(params) {
  return request({
    url: `/ucapi/captcha/image/${process.env.VUE_APP_ID}/${params.captchaId}`,
    method: "get",
    params,
  });
}

// 注册
export function register(data) {
  return request({
    url: `/ucapi/auth/register/${process.env.VUE_APP_ID}`,
    method: "post",
    data: data,
  });
}

export function setPassword(data) {
  return request({
    url: `/ucapi/auth/resetPassword/${process.env.VUE_APP_ID}`,
    method: "post",
    data: data,
  });
}

// 获取组织树
export function getOrgTree(data) {
  return request({
    url: `/ework2/weike/region/getOrgTree`,
    method: "post",
    data: data,
  });
}
// 搜索组织机构
export function searchOrg(data) {
  return request({
    url: `/ework2/weike/region/searchOrg?searchKeyword=${data.searchKeyword}`,
    method: "post",
    data: data,
  });
}
export function getMajorTree(params) {
  return request({
    url: `/ework2/weike/major/majorTree`,
    method: "get",
    params,
  });
}
export function upload(data) {
  return request({
    url: `/ework2/weike/common/upload?bizPath=${data.bizPath}`,
    method: "post",
    data: {
      file: data.file,
    },
    headers: {
      "content-type": "multipart/form-data",
    },
  });
}

